/** Двоичная строка guard_out / guard_status (9 бит). */
export function formatGuardBits(value, length = 9) {
    let binary = (value >>> 0).toString(2);
    while (binary.length < length) {
        binary = '0' + binary;
    }
    return binary;
}
/** Последнее состояние из истории условий. */
export function getLastTransportCondition(items) {
    if (!items || items.length === 0) {
        return undefined;
    }
    return items[items.length - 1];
}
/** Безопасный доступ к data; null если точка состояния отсутствует. */
export function getConditionData(item) {
    var _a;
    return (_a = item === null || item === void 0 ? void 0 : item.data) !== null && _a !== void 0 ? _a : null;
}
export function hasTransportConditions(items) {
    var _a;
    return Array.isArray(items) && items.length > 0 && !!((_a = items[items.length - 1]) === null || _a === void 0 ? void 0 : _a.data);
}
/** Данные последнего condition или null, если история пуста. */
export function getLastConditionData(items) {
    return getConditionData(getLastTransportCondition(items));
}
